<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  @if(visible){
  <div>
    @if(isJson){
    @if(isJson){
    <div class="jk-grid-cols-2">
      <mat-select [(ngModel)]="bookTypeItem" matTooltip="格式" placeholder="匯出格式">
        @for(idNameItem of bookTypeList; track idNameItem) {
        <mat-option [value]="idNameItem">{{idNameItem.name}}</mat-option>
        }
      </mat-select>
      <button mat-flat-button color="primary" (click)="doExport()">匯出</button>
      <!-- <app-jkcombobox  [styleDisplay]="'flex'" label="匯出格式" [(value)]="bookType" [items]="bookTypeList">
         </app-jkcombobox> -->
    </div>
    }

    <pre>{{ jsonObj | json }}</pre>
    }
    @if(!isAbout){
    <div>
      <!-- <app-jktextarea [height]="'600px'" [(value)]="value" [readOnly]="false">
      </app-jktextarea> -->
      <textarea matImput class="jk-textarea-area" [rows]="rows" [hidden]="!visible" [disabled]="disabled"
        [(value)]="value"
        [ngStyle]="{'min-height': minHeight + 'px', 'max-height': maxHeight + 'px', 'height': height }"
        [readOnly]="false" [placeholder]="label">
    </textarea>

    </div>
    }
    @if(isAbout){
    <div>
      <textarea matImput class="jk-textarea-area" [rows]="rows" [hidden]="!visible" [disabled]="disabled"
        [(value)]="platformValue"
        [ngStyle]="{'min-height': minHeight + 'px', 'max-height': maxHeight + 'px', 'height': height }"
        [readOnly]="false" [placeholder]="label">
    </textarea>
    </div>
    }
  </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="primary" cdkFocusInitial
    (click)="onNoClick(true)">確定</button>
  <button mat-flat-button color="warn" (click)="onNoClick(false)">取消</button>
  <button mat-flat-button (click)="doCopy()">複製</button>
</mat-dialog-actions>
